import { render, staticRenderFns } from "./payment-type-delivery-melaregalo.vue?vue&type=template&id=352427d2&"
import script from "./payment-type-delivery-melaregalo.vue?vue&type=script&lang=js&"
export * from "./payment-type-delivery-melaregalo.vue?vue&type=script&lang=js&"
import style0 from "./payment-type-delivery-melaregalo.vue?vue&type=style&index=0&id=352427d2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAlert,VBtn,VCol,VRow})
